import { FieldType } from '@sonar-software/sonar-core';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import React from 'react';

import { capitalize, enumStringKeys } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { FilterOption, OptionFilter } from '@periscopes/general/filters';

const options: Array<FilterOption> = enumStringKeys(FieldType).map((key) => ({
	label: FieldType[ key ],
	value: FieldType[ key ]
}));

export const FieldTypeFilter: FilterComponent<Array<FieldType>> = (props) => {
	const { format, id, onChange, value } = props;

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				value: options
					.filter((option) => (Array.isArray(value) ? value : [])?.includes(option.value as FieldType))
					.map((option) => option.label)
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				mode='multiple'
				onChange={ (selection: Array<FieldType>) => {
					onChange({
						[ id ]: {
							format,
							value: selection
						}
					});
				} }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(capitalize(COPY_SPECIFIC.FIELD_TYPE)) }
				showArrow
				value={ value } />
		</FilterComponent>
	);
};
